import { useState } from "react";
import { useNavigate, useLocation, Link, Outlet } from "react-router-dom";

export default function MainLayout() {
  const [open, setOpen] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const role = String(user.role || "").toLowerCase().trim();

  const logout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const isActive = (path) => {
    const current = location.pathname;
    if (path === "/") return current === "/";
    return current === path || current.startsWith(path + "/");
  };

  const navStyle = (path) => {
    const active = isActive(path);

    return {
      ...styles.link,
      background: active ? "#1b3a57" : "transparent",
      color: active ? "#fff" : "#e0e6ed",
      boxShadow: active ? "0 2px 6px rgba(0,0,0,0.2)" : "none"
    };
  };

  return (
    <div style={{ display: "flex" }}>

      {/* ================= SIDEBAR ================= */}
      <div style={styles.sidebar(open)}>

        {/* TOGGLE */}
        <div style={styles.toggle} onClick={() => setOpen(!open)}>
          ☰
        </div>

        {open && (
          <>
            <h2 style={styles.logo}>SIMS</h2>

            {/* DASHBOARD (ALL ROLES) */}
            <Link to="/" style={navStyle("/")}>
              📊 Dashboard
            </Link>

            {/* ================= ADMIN ================= */}
            {role === "admin" && (
              <>
                <NavItem path="/qr" label="🔳 QR Generator" />
                <NavItem path="/assign-salesman" label="👤 Assign Salesman" />
                <NavItem path="/assign-manager" label="🧑‍💼 Assign Manager" />
              </>
            )}

            {/* ================= MANAGER ================= */}
            {role === "manager" && (
              <>
                <NavItem path="/manager" label="🧑 Manager Approval" />
                <NavItem path="/manager-reports" label="📊 Reports" />
              </>
            )}

                     {/* ================= CEO ================= */}
           {role === "ceo" && (
  <>
    <NavItem path="/final-approval" label="✅ Final Approval" />
    <NavItem path="/ceo-reports" label="📊 CEO Reports" />
  </>
)}

            {/* ================= FINANCE (FIXED) ================= */}
            {role === "finance" && (
              <>
                <NavItem path="/payouts" label="💰 Manage Payouts" />
                <NavItem path="/payout-history" label="📋 Payout History" />
              </>
            )}

            {/* ================= SALESMAN ================= */}
            {role === "salesman" && (
              <>
                <NavItem path="/sales" label="📷 New Claim" />
                <NavItem path="/my-claims" label="📋 My Claims" />
              </>
            )}

            {/* LOGOUT */}
            <hr style={styles.divider} />

            <p style={styles.logout} onClick={logout}>
              🚪 Logout
            </p>
          </>
        )}
      </div>

      {/* ================= CONTENT ================= */}
      <div style={styles.content}>
        <div style={styles.topbar}>
          <h3>SIMS Panel</h3>
        </div>

        <div style={styles.body}>
          <Outlet />
        </div>
      </div>

    </div>
  );
}

// ================= NAV ITEM =================
const NavItem = ({ path, label }) => {
  const location = useLocation();

  const isActive =
    location.pathname === path ||
    location.pathname.startsWith(path + "/");

  return (
    <Link
      to={path}
      style={{
        ...styles.link,
        background: isActive ? "#3f5cffff" : "transparent",
        color: isActive ? "#fff" : "#e0e6ed"
      }}
    >
      {label}
    </Link>
  );
};

// ================= STYLES =================
const styles = {
  sidebar: (open) => ({
    width: open ? 230 : 70,
    background: "#2c5178",
    color: "#fff",
    minHeight: "100vh",
    padding: 15,
    transition: "0.3s"
  }),

  toggle: {
    cursor: "pointer",
    marginBottom: 20,
    fontSize: 20
  },

  logo: {
    marginBottom: 20
  },

  link: {
    display: "block",
    padding: "12px 14px",
    borderRadius: "8px",
    margin: "6px 0",
    fontWeight: "500",
    transition: "all 0.2s ease"
  },

  logout: {
    padding: "12px",
    borderRadius: "8px",
    marginTop: 10,
    cursor: "pointer",
    color: "#ff6b6b",
    fontWeight: "bold"
  },

  divider: {
    margin: "15px 0",
    borderColor: "#ffffff33"
  },

  content: {
    flex: 1,
    background: "#f5f7fb"
  },

  topbar: {
    background: "#fff",
    padding: 15,
    borderBottom: "1px solid #ddd"
  },

  body: {
    padding: 20
  }
};